export default "__VITE_ASSET__cvTPkpKR__"